import { useState } from "react";
import "./style.css";

export default function DeleteGroupModal({
  conversation,
  onConfirm,
  onClose,
  isVisible,
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isVisible) return null;

  const groupName = conversation?.name || "this group";

  const handleConfirm = async () => {
    if (isSubmitting) return;
    try {
      setIsSubmitting(true);
      await onConfirm();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="leave_group_modal_overlay"
      onClick={isSubmitting ? undefined : onClose}
    >
      <div
        className="leave_group_modal delete_group_modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="leave_group_header">
          <h3>Delete Group</h3>
          <button
            className="close_btn"
            onClick={onClose}
            disabled={isSubmitting}
            aria-label="Close delete group dialog"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>
        </div>

        <div className="leave_group_content">
          <div className="leave_group_icon" aria-hidden="true">🗑️</div>
          <p className="leave_group_description">
            Delete <strong>{groupName}</strong> from your chat list?
          </p>
          <p className="leave_group_note">
            This will remove the conversation history from your chat list.
            This action cannot be undone for your view.
          </p>
        </div>

        <div className="leave_group_actions">
          <button
            className="cancel_btn"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            className="leave_btn delete_btn"
            onClick={handleConfirm}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Deleting…" : "Delete Group"}
          </button>
        </div>
      </div>
    </div>
  );
}
